import { useGetApiV1ClassroomdisciplineSharedClassRooms } from '@/shared/api/generated';

import { mapDropdownOptions, useDebouncedFilter } from './useLookupSearch';

/**
 * Busca de salas de aula por texto (debounce + mínimo de 3 caracteres) para o
 * autocomplete de sala. Consome o lookup `shared/class-rooms` do Kubb.
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @returns `{ options, isLoading, isQuerySuccess }`.
 */
export function useClassRoomSearchDropdown(filter = '') {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1ClassroomdisciplineSharedClassRooms(
    isReady ? { Search: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
